import { InjectionToken, Provider } from '@angular/core'
import { environment } from '../../environments/environment'

export const dealingCardsPollTimeoutToken = new InjectionToken<number>(
  'DealingCardsPollTimeoutToken',
)

export const dealingCardsPollTimeoutProvider: Provider = {
  provide: dealingCardsPollTimeoutToken,
  useValue: environment.dealingCardsPollTimeoutInMilliseconds,
}
